import { showToast } from '../../Components/ToastNotifications';

const { REACT_APP_PROTOCOL, REACT_APP_HOST, REACT_APP_PORT } = process.env;
export const BASE_URL = `${REACT_APP_PROTOCOL}://${REACT_APP_HOST}:${REACT_APP_PORT}`;

export function putAccessToken(token) {
  localStorage.setItem('accessToken', token);
}

export function getAccessToken() {
  return localStorage.getItem('accessToken');
}

export function putRefreshToken(token) {
  return localStorage.setItem('refreshToken', token);
}

export function getRefreshToken() {
  return localStorage.getItem('refreshToken');
}

export function deleteToken() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
}

export async function fetchWithAuth(url, options = {}) {
  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
}

// Intercepts the response to show a toast message khusus penolakan
// scope/RBAC pada 403.
//
// PENTING: back-end sudah punya banyak `AuthorizationError` (403) lain yang
// TIDAK ADA hubungannya dengan scope/RBAC -- mis. "Data registrasi BUMDes
// tidak ditemukan untuk pengguna ini." (kondisi normal: user belum daftar
// BUMDes), atau cek kepemilikan record (mentor mengakses sesi kehadiran
// orang lain). Mencocokkan berdasarkan STATUS 403 SAJA menangkap semua kasus
// itu juga dan menampilkan toast "Akses Terbatas" yang salah konteks --
// sudah pernah terjadi, jangan diulang. Karena itu di sini dicocokkan lewat
// pola PESAN yang spesifik dihasilkan rbacExtension.js (back-end) dan
// penolakan scope native Hapi, bukan status code semata.
const RBAC_REJECTION_PATTERNS = [
  /^Anda tidak memiliki izin '.+' untuk aksi ini\.$/,
  /^Route ini khusus untuk employee \(admin\)\.$/,
];

function isRbacRejection(data) {
  if (data.statusCode === 403 && data.error === 'Forbidden' && data.message === 'Insufficient scope') {
    return true;
  }
  return RBAC_REJECTION_PATTERNS.some((pattern) => pattern.test(data.message || ''));
}

async function parseResponse(response) {
  try {
    const data = await response.json();

    if (response.status === 403 && isRbacRejection(data)) {
      showToast(
        `Akses Terbatas: ${data.message}`,
        'danger',
      );
    }

    return data;
  } catch (error) {
    // If response is not JSON, it will fall back here
    throw error;
  }
}

// HTTP request helpers (returns parsed JSON response)
export async function get(path) {
  const response = await fetchWithAuth(`${BASE_URL}${path}`);
  return parseResponse(response);
}

export async function post(path, body) {
  const response = await fetchWithAuth(`${BASE_URL}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  return parseResponse(response);
}

export async function put(path, body) {
  const response = await fetchWithAuth(`${BASE_URL}${path}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  return parseResponse(response);
}

export async function patch(path, body) {
  const response = await fetchWithAuth(`${BASE_URL}${path}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  return parseResponse(response);
}

export async function del(path, body) {
  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (body) {
    options.body = JSON.stringify(body);
  }
  const response = await fetchWithAuth(`${BASE_URL}${path}`, options);
  return parseResponse(response);
}

// Public HTTP request helpers (no Auth header)
export async function publicGet(path) {
  const response = await fetch(`${BASE_URL}${path}`);
  return parseResponse(response);
}

export async function publicPost(path, body) {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  return parseResponse(response);
}

export async function publicPut(path, body) {
  const response = await fetch(`${BASE_URL}${path}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  return parseResponse(response);
}
